import React from 'react';
import i18n from "../i18n";
import routes from "../routes";
import * as api from "../utils/api";
import Loading from "../components/Loading";
import FileChooseButton from "../components/FileChooseButton";
import HomeButton from "../components/HomeButton";
import AppContext from "../contexts/AppContext";
import * as creativeUtils from "../utils/creative";
import * as photolabUtils from "../utils/photolab";
import {getLocationQueryObject} from "../utils/text";
import {hitEvent, hits, logEvent, userEvents} from "../utils/log";
import Modal from "../components/Modal";
import * as webviewUtils from "../utils/webview";
import ImageView from "../components/ImageView";

const FETCH_INTERVAL = 1000;
const GROUP_CROP = "crop";
const GROUP_BARBIE = "barbie";

const SHARE_INSTAGRAM_STORY = "instagram_story";
const SHARE_INSTAGRAM_FEED = "instagram_feed";

const TABS = [
  GROUP_BARBIE,
];

export default class ResultPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      tab: TABS[0],
      defaultTab: TABS[0],
      photo: null,
      creatives: null,
    };

    this.fetchResult = this.fetchResult.bind(this);
    this.handleResultFetched = this.handleResultFetched.bind(this);
    this.handleFileSelected = this.handleFileSelected.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleDownloadButtonClick = this.handleDownloadButtonClick.bind(this);
    this.handleRefreshButtonClick = this.handleRefreshButtonClick.bind(this);
    this.handleShareClick = this.handleShareClick.bind(this);
    this.handleVectorRefreshButtonClick = this.handleVectorRefreshButtonClick.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.renderTab = this.renderTab.bind(this);
    this.renderTabContainer = this.renderTabContainer.bind(this);

    this.fecthTimer = null;
  }

  componentDidMount() {
    this.fetchResult();
  }

  componentWillUnmount() {
    clearTimeout(this.fecthTimer)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.match.params.hash !== prevProps.match.params.hash) {
      this.setState({
        isLoading: true
      }, () => {
        this.fetchResult();
      });
    }
  }

  fetchResult() {
    api.fetchPhotoByHash(this.props.match.params.hash)
      .then(this.handleResultFetched)
      .catch((err) => {
        console.error(err);
        this.props.history.replace(routes.ERROR);
      });
  }

  handleResultFetched(res) {
    const query = getLocationQueryObject();
    const isNewResult = this.state.photo === null || this.state.photo.id !== res.photo.id;
    const nextState = {
      isLoading: false,
      photo: res.photo,
      creatives: res.creatives,
    };

    if (isNewResult) {
      const tab = TABS.includes(query.t) ? query.t : TABS[Math.floor(Math.random() * TABS.length)];
      nextState.defaultTab = tab;
      nextState.tab = tab;

      logEvent(userEvents.PAGE_RESULT, {
        photo_id: nextState.photo.id,
        is_owner: nextState.photo.is_owner,
        ref: nextState.photo.is_owner ? undefined : (query.ref || "unspecified")
      });
    }

    let cb = undefined;

    if (nextState.creatives.filter(creativeUtils.creativeIsProcessing).length > 0) {
      cb = () => {
        this.fecthTimer = setTimeout(this.fetchResult, FETCH_INTERVAL);
      };
    }

    this.setState(nextState, cb);
  }

  handleFileSelected(file) {
    hitEvent(hits.PHOTO_SELECT);
    logEvent(userEvents.PHOTO_SELECT, {page: "result"});

    this.props.history.push(routes.CREATE, {file});
  }

  handleDownload(creative, hdCreative) {
    const logParams = {
      photo_id: this.state.photo.id,
      creative_id: creative.id,
      template_id: creative.template.id,
      group: this.state.tab,
      default_tab_group: this.state.defaultTab,
    };

    if (hdCreative) {
      logParams.sr_creative_id = hdCreative.id;
      logParams.sr_template_id = hdCreative.template.id;
    }

    hitEvent(hits.DOWNLOAD_START);
    logEvent(userEvents.DOWNLOAD_START, logParams);

    setTimeout(() => {
      if (window.clientConfig.isWebview) {
        webviewUtils.webviewShareDownload(creative.file.url);
      } else {
        const url = new URL(this.state.photo.download_url);
        url.searchParams.set("creative_id", (hdCreative || creative).id);
        window.location.href = url.toString();
      }
    }, 100);
  }

  handleDownloadButtonClick(e, creative, withHD, cb) {
    hitEvent(hits.DOWNLOAD);
    logEvent(userEvents.DOWNLOAD, {
      photo_id: this.state.photo.id,
      creative_id: creative.id,
      template_id: creative.template.id,
      group: this.state.tab,
      default_tab_group: this.state.defaultTab,
    });

    if (withHD) {
      const hdCreative = this.state.creatives.find((c) => c["extra"] === "hd_" + creative.id);
      if (hdCreative && creativeUtils.creativeIsProcessed(hdCreative)) {
        this.handleDownload(creative, hdCreative);
        return;
      }
    }

    this.handleDownload(creative, creative);

    cb && cb();

    /*this.context.pushModal(<DownloadModal
      key="ResultPage-DownloadModal"
      tab={this.state.tab}
      photo={this.state.photo}
      creative={creative}
      withHD={withHD}
      downloadHandler={this.handleDownload}
    />);*/
  }

  handleShareClick(creative, provider) {
    logEvent(userEvents.SHARE, {
      photo_id: this.state.photo.id,
      creative_id: creative.id,
      provider,
    });

    switch (provider) {
      case SHARE_INSTAGRAM_STORY:
        webviewUtils.webviewShareInstagramStory(window.location.href.split("#")[0], creative.file.url);
        break;
      case SHARE_INSTAGRAM_FEED:
        webviewUtils.webviewShareInstagramFeed(window.location.href.split("#")[0], creative.file.url);
        break;
    }
  }

  handleRefreshButtonClick(group) {
    logEvent(userEvents.TAB_REFRESH, {group});
    api.refreshPhotoGroup(this.state.photo.id, group).then(this.handleResultFetched);
  }

  handleVectorRefreshButtonClick(templateId) {
    logEvent(userEvents.TAB_REFRESH, {group: "vector", template_id: templateId});
    api.refreshPhotoVector(this.state.photo.id, templateId).then(this.handleResultFetched);
  }

  handleTabClick(group) {
    if (this.state.tab === group) {
      return;
    }

    logEvent(userEvents.TAB_SELECT, {
      group,
      prev_group: this.state.tab
    });

    this.setState({tab: group});
  }

  renderTab(group) {
    const tabClassNames = ["collage__tab_" + group];
    if (this.state.tab === group) {
      tabClassNames.push("active-tab");
    }

    const creative = this.state.creatives.find((creative) => creative.group === group && creative.is_selected);
    let children = undefined;
    if (creative && creativeUtils.creativeIsProcessed(creative)) {
      children = <img src={creative.file.url} alt="Preview" />;
    }

    return <button
      key={group}
      className={tabClassNames.join(" ")}
      children={children}
      onClick={() => this.handleTabClick(group)} />;
  }

  renderTabContainer(commonTabSettings) {
    switch (this.state.tab) {
      case GROUP_BARBIE:
        return <SimpleTab group={GROUP_BARBIE} {...commonTabSettings} canBeRefreshed={false} />;
      default:
        return <div />;
    }
  }

  render() {
    if (this.state.isLoading) {
      const photo = this.props.location.state
        && this.props.location.state.photo
        && this.props.location.state.photo.file
        && this.props.location.state.photo.file.url;

      return <Loading image={photo} />;
    }

    const shareUrl = new URL(this.state.photo.share_url);
    shareUrl.searchParams.set("tab", this.state.tab);

    const isOwner = this.state.photo.is_owner;
    const isGuest = !isOwner;

    const commonTabSettings = {
      photo: this.state.photo,
      creatives: this.state.creatives,
      shareUrl,
      isOwner,
      isGuest,
      onDownloadButtonClick: (e, creative, withHD, cb) => this.handleDownloadButtonClick(e, creative, withHD, cb),
      onRefreshButtonClick: this.handleRefreshButtonClick,
      onShareClick: this.handleShareClick,
      canBeRefreshed: this.state.photo.can_refresh,
    };

    return <main className="collage-page">
      <div className="container">
        <HomeButton hidden={isGuest} page={"result"} />
        <h1 hidden={isOwner}
            className="main-title"
            dangerouslySetInnerHTML={{__html: i18n.t("landing__title")}} />
      </div>
      <div className="collage-page-content">
        {/* <h2 hidden={isGuest} children={i18n.t("collage__title")} /> */}
        {/* <div className="tabs-container">
          {TABS.length > 1 && TABS.map((group) => this.renderTab(group))}
        </div> */}
        {this.renderTabContainer(commonTabSettings)}
      </div>

      <div className="container" hidden={isOwner}>
        <p className="collage-page-text" dangerouslySetInnerHTML={{__html: i18n.t("collage__text_guest")}} />
        <FileChooseButton
          onFileSelected={this.handleFileSelected}
          className="btn-upload-foto"
          children={i18n.t("collage__select_photo")} />
      </div>
    </main>;
  }
}

ResultPage.contextType = AppContext;

export class VectorTab extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isRefreshView: false,
      task: null,
    };

    this.fetchTask = this.fetchTask.bind(this);
    this.handleRefreshButtonClick = this.handleRefreshButtonClick.bind(this);
    this.handleFetchTask = this.handleFetchTask.bind(this);
    this.handleSelectTemplate = this.handleSelectTemplate.bind(this);

    this.fetchTimer = null;
  }

  componentWillUnmount() {
    clearTimeout(this.fetchTimer);
  }

  handleRefreshButtonClick() {
    const nextState = {isRefreshView: true};

    if (this.props.photo.vector_preview_task) {
      nextState.task = this.props.photo.vector_preview_task;
    } else {
      this.fetchTask();
    }

    this.setState(nextState);
  }

  fetchTask() {
    api.fetchPhotoVectorPreviewTask(this.props.photo.id)
      .then((res) => this.handleFetchTask(res.task))
      .catch((err) => console.error(err));
  }

  handleFetchTask(task) {
    if (photolabUtils.taskIsProcessing(task)) {
      this.fetchTimer = setTimeout(this.fetchTask, FETCH_INTERVAL);
    }

    this.setState({task});
  }

  handleSelectTemplate(templateId) {
    this.setState({
      isRefreshView: false,
      task: null,
    }, () => this.props.onTemplateSelect(templateId));
  }

  render() {
    if (this.state.isRefreshView) {
      if (!this.state.task || photolabUtils.taskIsProcessing(this.state.task)) {
        return <div className="creative-holder">
        <div className="creative-holder-placeholder" />
        <div className="loader-video">
          <span className="item-loader first-item-loader" />
          <span className="item-loader second-item-loader" />
          <span className="item-loader third-item-loader" />
        </div>
      </div>;
      }

      if (photolabUtils.taskIsProcessed(this.state.task)) {
        const ts = Object.keys(this.state.task.response.results);

        return <div className="choose-page">
          <div className="container">
            <h2>Almost there!</h2>
            <p>Choose a portrait.</p>
          </div>
          <div className="choose-items">
            {ts.map((templateId) => <div className="choose-item-container" key={templateId}>
              <div className="choose-item">
                <img
                  src={this.state.task.response.results[templateId]}
                  width={100}
                  alt={templateId}
                  onClick={() => this.handleSelectTemplate(templateId)} />
              </div>
            </div>)}
          </div>
        </div>;
      }

      return <div>task failed</div>;
    }

    const tabProps = {...this.props};
    tabProps.onRefreshButtonClick = this.handleRefreshButtonClick;

    return <SimpleTab {...tabProps} />;
  }
}

export class SimpleTab extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      saved: false,
    };

    this.saveClick = this.saveClick.bind(this);
  }

  componentDidMount() {
    if (window.location.hash.split('#')[1] === "saved") {
      this.setState({saved: true});
    }
  }

  saveClick() {
    this.setState({saved: true});

    if (window.clientConfig.isWebview) {
      window.location.hash = '#saved';
    }
  }

  render() {
    const { creatives, isGuest } = this.props;
    const canBeRefreshed = !!this.props.canBeRefreshed;
    const group = creatives.filter((creative) => creative.group === this.props.group);

    const creative = group.find((creative) => creative.is_selected);
    const creativeIsProcessing = !creative || creativeUtils.creativeIsProcessing(creative);

    const previewCreative = group.find((creative) => !creative.is_selected);
    const previewCreativeIsProcessed = previewCreative && creativeUtils.creativeIsProcessed(previewCreative);

    const isWeb = window.clientConfig.isWeb;
    const isWebviewIOS = window.clientConfig.isWebviewIOS;
    const isWebviewAndroid = window.clientConfig.isWebviewAndroid;
    const hasInstagramApp = this.context.installedApps.instagram;

    return <div>
      <div className="creative-holder">
        {creativeIsProcessing && <div className="creative-holder-placeholder" />}

        {previewCreativeIsProcessed && <div className="wait-video">
          <img src={previewCreative.file.url} alt="Creative" />
        </div>}

        {creative && <CreativeView creative={creative} />}

        <div className="loader-video">
          <span className="item-loader first-item-loader" />
          <span className="item-loader second-item-loader" />
          <span className="item-loader third-item-loader" />
        </div>
      </div>

      <div className="btns-container" hidden={this.state.saved}>
        <button
          className="btn-upload-foto"
          children={i18n.t("collage__download")}
          hidden={creativeIsProcessing || isGuest}
          onClick={(e) => this.props.onDownloadButtonClick(e, creative, this.props.withHD, this.saveClick)} />

        <button
          className="btn-refresh-foto"
          hidden={isGuest || creativeIsProcessing || !canBeRefreshed}
          onClick={() => this.props.onRefreshButtonClick(this.props.group)}>
          <SvgRefreshIcon />
          <span children={i18n.t("collage__refresh")} />
        </button>
      </div>

      {/*this.state.saved && <p className="status-message"><SvgCheckIcon/> <span dangerouslySetInnerHTML={{__html: i18n.t("collage__downloaded")}} /></p>*/}

      <div className="share-block" hidden={!this.state.saved}>
        <p dangerouslySetInnerHTML={{__html:i18n.t("collage__share_tag")}} />
        <div className="btns-container" hidden={isWeb || !hasInstagramApp}>
          <button
            className="btn-insta btn-android"
            hidden={isWebviewAndroid}
            onClick={() => this.props.onShareClick(creative, SHARE_INSTAGRAM_FEED)}>
            <SvgInstagramIconTransparent />
            <span children={i18n.t("btn-insta-title-android")} />
          </button>
          <button
            className="btn-insta btn-ios"
            hidden={isWebviewIOS}
            onClick={() => this.props.onShareClick(creative, SHARE_INSTAGRAM_FEED)}>
            <SvgInstagramIconTransparent />
            <span children={i18n.t("btn-insta-title-post")} />
          </button>
          <button
            className="btn-insta btn-ios"
            hidden={isWebviewIOS}
            onClick={() => this.props.onShareClick(creative, SHARE_INSTAGRAM_STORY)}>
            <SvgInstaStoriesIconTransparent />
            <span children={i18n.t("btn-insta-title-stories")} />
          </button>
        </div>
      </div>
    </div>;
  }
}

SimpleTab.contextType = AppContext;

function CreativeView({creative, height}) {
  if (!creative.file) {
    return <React.Fragment />;
  }

  if (creative.file.is_video) {
    return <video style={{maxHeight: height}} playsInline muted loop autoPlay controls={false}>
      <source src={creative.file.url} type="video/mp4" />
    </video>;
  }

  return <ImageView image={creative.file} backgrounded />;
}

class DownloadModal extends Modal {

  constructor(props) {
    super(props);

    this.state = {
      creative: null,
    };

    this.fetchCreative = this.fetchCreative.bind(this);
    this.handleCreative = this.handleCreative.bind(this);
    this.handleDownload = this.handleDownload.bind(this);

    this.fetchTimer = null;
  }

  componentDidMount() {
    this.fetchCreative();
  }

  componentWillUnmount() {
    clearTimeout(this.fetchTimer);
  }

  fetchCreative() {
    if (this.props.withHD) {
      api.fetchHDCreative(this.props.photo.id, this.props.creative.id)
        .then((res) => this.handleCreative(res.creative))
        .catch((err) => {
          console.error(err);
        });
    } else {
      /*api.fetchCreative(this.props.photo.id, this.props.creative.id)
        .then((res) => this.handleCreative(res.creative))
        .catch((err) => {
          console.error(err);
        });*/
      this.handleCreative(this.props.creative);
    }
  }

  handleCreative(creative) {
    this.setState({creative});

    if (creativeUtils.creativeIsProcessing(creative)) {
      this.fetchTimer = setTimeout(this.fetchCreative, FETCH_INTERVAL);
      return;
    }

    if (creativeUtils.creativeIsProcessed(creative)) {
      this.props.downloadHandler(this.props.creative, creative);
    }
  }

  handleDownload(e) {
    this.props.downloadHandler(
      this.props.creative, // SD from props
      this.state.creative  // HD from state
    );
  }

  renderModal() {
    const creativeIsProcessed = this.state.creative && creativeUtils.creativeIsProcessed(this.state.creative);
    const creativeIsProcessing = this.state.creative && creativeUtils.creativeIsProcessing(this.state.creative);

    const loader = <div className="loader-video">
      <span className="item-loader first-item-loader" />
      <span className="item-loader second-item-loader" />
      <span className="item-loader third-item-loader" />
    </div>;

    const buttons = <div className="btns-container">
      <button
        className="btn-upload-foto"
        children={i18n.t("download_modal__dismiss_button")}
        onClick={() => this.dismiss()} />
      <button
        hidden={!this.props.withHD || window.clientConfig.isWebview}
        className="btn-upload-foto download"
        children={i18n.t("download_modal__download_button")}
        onClick={this.handleDownload} />
    </div>;

    return <div className="modal-container">
      <div className="modal">
        <SvgModalBackground />
        <h3 dangerouslySetInnerHTML={{__html: i18n.t("download_modal__title")}} />
        <p dangerouslySetInnerHTML={{__html: i18n.t("download_modal__message")}} />
        {creativeIsProcessing && <p dangerouslySetInnerHTML={{__html: i18n.t("download_modal__message_wait")}} />}
        {creativeIsProcessed && this.props.withHD && <p dangerouslySetInnerHTML={{__html: i18n.t("download_modal__message_ready")}} />}
        {creativeIsProcessed ? buttons : loader}
      </div>
      <SvgCloudTop />
      <SvgCloudRight />
      <SvgCloudLeft />
    </div>;
  }
}

function SvgCheckIcon() {
  return <svg viewBox="0 0 54 44">
    <g fill="none" fillRule="evenodd">
        <g>
            <g>
                <path d="M0 0H54V44H0z" transform="translate(-290 -1576) translate(290 1576)"/>
                <path fill="#8CB3E5" fillRule="nonzero" stroke="#8CB3E5" strokeWidth="3" d="M50.297 4.703c-.937-.938-2.457-.938-3.394 0L18.149 33.457 7.097 22.404c-.937-.937-2.457-.937-3.394 0-.937.937-.937 2.457 0 3.394l12.75 12.75c.936.937 2.457.936 3.393 0L50.297 8.096c.937-.937.937-2.457 0-3.394z" transform="translate(-290 -1576) translate(290 1576)"/>
            </g>
        </g>
    </g>
  </svg>;
}

function SvgRefreshIcon() {
  return <svg viewBox="0 0 72 71">
    <g fill="none" fillRule="evenodd">
      <g fill="#000" fillRule="nonzero" stroke="#000" strokeWidth="2.125">
        <g>
          <g>
            <path d="M33.786 3.4c5.344 0 10.696 1.517 15.477 4.387 3.033 1.824 5.759 4.118 8.074 6.796l-7.988-.264c-.938-.032-1.725.705-1.755 1.643-.031.938.704 1.724 1.643 1.755l11.052.365c.635.262 1.366.115 1.85-.371.486-.486.63-1.216.368-1.851l-.363-11.05c-.022-.938-.8-1.682-1.739-1.66-.938.02-1.683.798-1.662 1.736l.002.038.21 6.375c-2.339-2.5-5.012-4.664-7.942-6.428C45.703 1.683 39.746 0 33.786 0 24.266 0 15.49 3.925 9.075 11.052 3.393 17.367 0 25.864 0 33.788c0 .938.76 1.7 1.7 1.7s1.7-.762 1.7-1.7c0-7.104 3.066-14.753 8.202-20.459C17.364 6.926 25.241 3.4 33.787 3.4zM66.3 32.086c-.94 0-1.7.761-1.7 1.7 0 7.104-3.066 14.753-8.202 20.46-5.761 6.401-13.64 9.927-22.184 9.927-5.344 0-10.696-1.516-15.478-4.386-3.032-1.825-5.758-4.12-8.073-6.797l7.99.264c.937.03 1.723-.705 1.753-1.644.031-.938-.704-1.724-1.642-1.755L7.71 49.49c-.635-.261-1.366-.114-1.85.371-.486.486-.631 1.216-.368 1.85l.363 11.05c.022.94.8 1.683 1.739 1.662.938-.02 1.683-.8 1.662-1.738l-.002-.036-.21-6.375c2.339 2.5 5.01 4.663 7.942 6.428 5.31 3.187 11.267 4.87 17.227 4.87 9.52 0 18.297-3.924 24.711-11.051C64.607 50.206 68 41.708 68 33.786c0-.939-.76-1.7-1.7-1.7h0z" transform="translate(-1005 -1759) translate(988 1761) translate(19)"/>
          </g>
        </g>
      </g>
    </g>
  </svg>;
}

function SvgCloudLeft() {
  return <svg className="cloud-left" viewBox="0 0 154 118">
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path fill="#FFF" d="M97.163 11.01C52.265 4.872 2.771 27.24 10.88 63.792c8.108 36.552 79.76 59.663 117.264 34.905 37.504-24.758-4.7-84.076-30.98-87.689z" transform="translate(-97 -1991) translate(97 1991)"/>
          <path fill="#D1D2D4" d="M121.21 22c5.947 16.571 4.646 34.003-11.68 44.845C80.33 86.24 30.741 76.61 6 54.147c0 .7 0 1.372.265 2.072 8.177 37.016 80.17 60.42 117.839 35.348C149.137 74.888 138.757 42.714 121.21 22z" transform="translate(-97 -1991) translate(97 1991)"/>
          <path fill="#1E1E1E" d="M108.343 116.384c-20.987 3.585-42.57 1.176-62.229-6.945-24.485-9.861-40.898-25.9-44.961-44.005-3.392-14.273.813-29.274 11.146-39.763C30.156 6.372 65.093-3.49 99.23 1.124c21.384 2.89 47.233 30.91 53.327 57.683 4.571 20.04-1.79 36.847-17.963 47.371-8 5.056-16.916 8.522-26.25 10.206zM62.901 21.191c-15.183 2.916-28.522 9.066-36.327 17.496-6.011 5.866-8.486 14.425-6.523 22.559 2.673 11.69 15.103 23.036 33.334 30.379 25.26 10.153 53.595 9.543 70.57-1.485 9.302-6.044 12.483-14.924 9.703-27.065-4.598-20.12-24.78-41.221-37.05-42.865-11.241-1.493-22.653-1.162-33.787.98h.08z" transform="translate(-97 -1991) translate(97 1991)"/>
        </g>
      </g>
    </g>
  </svg>;
}

function SvgCloudRight() {
  return<svg className="cloud-right" viewBox="0 0 240 227">
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path fill="#FFF" d="M128.611 68.266c-16.66-34.63-56.94-78.728-89.405-54.12-32.466 24.61-9.619 57.434 11.74 60.63C-11.01 101.447-7.558 215.54 61.955 219.807c57.514 3.512 72.984-42.252 72.984-42.252s113.402 18.754 96.307-73.012C216.747 26.749 128.61 68.266 128.61 68.266z" transform="translate(-947 -1920) translate(947 1920)"/>
          <path fill="#D1D2D4" d="M231.245 103.98c-4.88-26.115-18.127-38.717-33.537-43.98 12.633 98.723-79.865 66.99-79.865 66.99-45.515 48.451-93.37 5.935-106.123-7.103-13.882 42.358 2.856 96.112 50.236 98.921 57.513 3.502 72.983-42.12 72.983-42.12s113.401 18.775 96.306-72.708z" transform="translate(-947 -1920) translate(947 1920)"/>
          <path fill="#1E1E1E" d="M85.887 225.369c-7.986 1.488-16.128 1.96-24.232 1.406C30.567 224.893 7.524 202.19 1.48 167.54c-5.587-32.035 4.458-71.142 33.288-91.706-8.651-5.793-14.914-14.518-17.635-24.566-2.318-9.094-3.09-26.765 17.833-42.674C44.877.86 57.814-1.848 69.996 1.264c24.808 5.943 48.267 32.431 61.998 57.888 14.167-5.428 48.703-16.007 75.293-2.337 16.267 8.34 26.65 23.952 30.83 46.417 4.894 26.23.238 46.814-13.87 61.217-24.37 24.863-69.348 22.506-85.06 20.802-10.608 20.893-30.286 35.703-53.3 40.118zM55.544 14.432c-4.113.846-7.974 2.635-11.28 5.224C33.48 27.85 29.108 37.466 31.64 47.361c2.81 10.963 12.902 18.78 21.074 19.986l24.953 3.72-23.192 9.895c-31.898 13.714-43.533 53.292-38.25 83.549 4.907 28.14 22.42 45.81 46.838 47.315 51.251 3.126 65.46-36.867 65.578-37.263l1.979-5.758 5.936.97c.554.098 53.962 8.529 77.926-15.97 10.586-10.825 13.851-27.13 9.894-48.443-3.345-17.81-11.141-30.02-23.212-36.214-27.347-14.03-68.684 5.027-69.1 5.225l-6.292 3.067-3.087-6.392c-11.596-24.063-34.372-51.075-55.407-56.16-3.832-1.003-7.836-1.158-11.734-.456z" transform="translate(-947 -1920) translate(947 1920)"/>
          <path fill="#1E1E1E" d="M50 170.77c9.035 2.598 18.244 4.592 27.562 5.969 8.571 1.161 17.276 1.051 25.814-.326 8.483-1.453 16.657-4.261 24.186-8.31 8.128-4.468 15.663-9.875 22.438-16.103-2.493 9.706-8.044 18.425-15.886 24.95-7.95 6.834-17.703 11.41-28.177 13.223-10.461 1.72-21.206.747-31.155-2.82-9.595-3.384-18.129-9.094-24.782-16.583z" transform="translate(-947 -1920) translate(947 1920)"/>
        </g>
      </g>
    </g>
  </svg>;
}

function SvgCloudTop() {
  return <svg className="cloud-top" viewBox="0 0 225 185">
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path fill="#FFF" d="M132.993 60.203C48.137 31.583 2.67 69.428 8.5 102.953c5.83 33.526 74.01 76.637 102.258 50.312 16.813 29.25 77.896 46.486 101.172-41.086C235.205 24.607 170.8 25.957 170.8 25.957c-4.045-17.213-42.665-26.393-51.479-7.38-8.813 19.013 13.672 41.626 13.672 41.626z" transform="translate(-282 -184) translate(282 184)"/>
          <path fill="#D1D2D4" d="M184.703 31c9.262 16.968 13.995 32.616 11.073 53.541-7.812 55.665-71.016 62.372-87.864 33.377C87.169 137.098 31.37 126.614 8 102.559c.015.294.053.585.113.872 5.82 33.287 74.164 76.143 102.471 49.987 16.848 29.062 78.036 46.186 101.384-40.82 11.82-44.041-13.814-71.203-27.265-81.598z" transform="translate(-282 -184) translate(282 184)"/>
          <path fill="#1E1E1E" d="M162.225 184.084c-1.038.21-2.03.367-2.978.472-20.549 2.696-39.451-7.235-50.391-20.018-11.482 6.223-26.685 6.583-43.805.854-27.474-9.166-59.91-35.115-64.422-61.04-2.752-15.862 3.609-31.745 17.504-43.563 10.737-9.166 40.083-27.094 95.414-14.445-4.24-9.122-6.654-20.22-1.669-31.049C116.863 4.467 129.066-1.285 144.27.243c12.428 1.258 26.188 7.728 32.053 17.973 8.639 1.033 24.992 4.92 36.496 19.5 13.534 17.075 15.79 42.686 6.767 76.386-13.985 53.065-40.782 66.814-57.361 69.982zm-49.058-44.504l5.141 8.96c8.207 13.427 23.494 20.92 39.212 19.222 20.745-2.778 37.453-23.41 46.72-58.246 7.464-27.958 6.134-49.42-3.878-62.032-10.936-13.822-28.884-13.62-29.065-13.62l-6.629.134-1.51-6.407c-1.083-4.66-9.426-10.35-20.114-11.448-2.976-.291-12.875-.761-15.784 5.668-5.254 11.201 7.238 27.555 12.018 32.371l24.285 24.419-32.718-11.022c-42.842-14.427-80.79-12.523-101.468 5.13-9.38 7.953-13.754 18.28-11.995 28.339 2.999 17.205 27.982 39.742 53.462 48.232 8.816 2.935 25.051 6.474 34.928-2.71l7.395-6.99z" transform="translate(-282 -184) translate(282 184)"/>
        </g>
      </g>
    </g>
  </svg>;
}

function SvgModalBackground() {
  return <svg className="modal-bg" viewBox="0 0 1242 1681">
    <g fill="none" fillRule="evenodd">
      <g fill="#1E1E1E" fillRule="nonzero">
        <g>
          <path d="M134 281c23.078 12.302 45.44 25.637 67.535 39.344 22.096 13.707 43.874 27.918 65.546 42.287 21.672 14.37 42.946 29.323 63.954 44.647C352.044 422.602 372.893 438.19 393 455c-23.078-12.275-45.44-25.61-67.535-39.318-22.096-13.707-43.9-27.917-65.546-42.42-21.645-14.502-42.92-29.322-63.954-44.646C174.93 313.292 154.054 297.623 134 281zM219 232c21.945 18.029 43.015 36.935 63.686 56.187 20.672 19.252 41.105 38.902 61.272 58.74 20.167 19.836 39.804 40.099 59.281 60.76C422.717 428.348 441.796 449.169 460 471c-21.972-18.029-43.041-36.935-63.686-56.187-20.645-19.252-41.078-38.929-61.246-58.766-20.167-19.837-39.804-40.1-59.28-60.76C256.31 274.625 237.256 253.805 219 232zM235 163c16.647 14.915 32.364 30.68 47.79 46.71 15.426 16.029 30.32 32.483 45.135 49.07 14.815 16.587 28.966 33.599 42.825 50.93 13.86 17.33 27.586 34.872 40.25 53.29-16.673-14.889-32.391-30.653-47.79-46.683-15.399-16.03-30.294-32.484-45.135-49.07-14.841-16.588-29.02-33.6-42.931-50.956C261.23 198.934 247.664 181.418 235 163zM417 101c10.057 17.51 18.824 35.474 27.402 53.624 8.578 18.15 16.35 36.512 24.068 54.954 7.718 18.443 14.79 37.258 21.513 56.02 6.723 18.76 12.961 37.895 18.017 57.402-10.084-17.51-18.958-35.474-27.43-53.624-8.47-18.15-16.349-36.512-24.04-54.954-7.69-18.443-14.763-37.258-21.513-56.046-6.75-18.788-12.935-37.87-18.017-57.376zM489 101c5.97 16.508 10.71 33.228 14.94 50.054 4.23 16.826 8.032 33.758 11.405 50.716 3.374 16.958 6.292 34.075 8.622 51.271 2.555 17.226 4.235 34.567 5.033 51.959-5.97-16.508-10.71-33.228-14.94-50.054-4.23-16.826-8.032-33.758-11.405-50.742-3.374-16.985-6.265-34.075-8.595-51.271-2.33-17.197-4.364-34.42-5.06-51.933zM68 578c26.765 0 53.397 1.088 79.977 2.59 26.58 1.503 53.132 3.757 79.632 6.14 26.5 2.384 53 5.39 79.368 8.887 26.368 3.497 52.762 7.28 79.023 12.383-26.765 0-53.397-1.062-79.977-2.59-26.58-1.53-53.133-3.783-79.633-6.166-26.5-2.384-53-5.415-79.367-8.912C120.656 586.834 94.235 583.104 68 578zM0 636.64c31.901-3.473 63.802-5.693 95.703-7.468 31.902-1.776 63.803-2.977 95.704-3.969 31.901-.992 63.802-1.305 95.703-1.175 31.902.13 63.803.6 95.89 2.376-31.901 3.473-63.802 5.692-95.703 7.468-31.902 1.775-63.803 2.976-95.704 3.943-31.901.966-63.802 1.305-95.703 1.148-31.902-.156-63.91-.574-95.89-2.323zM100 1274c20.034-20.684 40.866-40.407 61.99-59.81 21.126-19.403 42.57-38.325 64.333-57.087 21.763-18.763 43.74-37.045 66.168-54.926 22.428-17.882 45.016-35.55 68.509-52.177-20.007 20.71-40.866 40.434-61.99 59.837-21.126 19.402-42.65 38.325-64.253 57.167-21.604 18.843-43.766 37.044-66.168 54.926-22.402 17.882-45.096 35.443-68.589 52.07zM65 1167c21.07-14.027 42.675-26.935 64.653-39.445 21.978-12.51 44.062-24.487 66.333-36.25 22.271-11.765 44.862-22.997 67.667-33.75 22.804-10.753 45.742-21.293 69.347-30.555-21.098 14.027-42.675 26.935-64.653 39.445-21.978 12.51-44.062 24.487-66.36 36.25-22.298 11.765-44.835 22.97-67.64 33.723C111.543 1147.171 88.631 1157.684 65 1167zM95 1091c15.067-9.134 30.612-17.097 46.343-24.66 15.732-7.564 31.675-14.541 47.699-21.305 16.024-6.765 32.313-12.996 48.788-18.642 16.475-5.646 33.084-11.185 50.17-15.393-15.04 9.161-30.612 17.124-46.317 24.66-15.704 7.537-31.675 14.568-47.831 21.305-16.157 6.738-32.313 12.996-48.788 18.642C128.588 1081.253 112.113 1086.9 95 1091zM547 1480c.53-22.45 2.332-44.739 4.558-66.948 2.226-22.21 5.061-44.34 8.082-66.496 3.021-22.157 6.731-44.1 10.891-66.044 4.16-21.944 8.64-43.808 14.469-65.512-.53 22.45-2.332 44.739-4.558 66.948-2.226 22.21-5.061 44.34-8.109 66.496-3.047 22.157-6.73 44.1-10.917 66.044-4.187 21.944-8.666 43.914-14.416 65.512zM443 1494c4.258-20.803 9.705-41.154 15.55-61.344 5.844-20.19 12.296-40.246 18.907-60.223 6.612-19.977 13.884-39.713 21.58-59.29 7.695-19.577 15.707-39.1 24.963-58.143-4.231 20.777-9.652 41.154-15.523 61.344-5.87 20.19-12.27 40.246-18.934 60.196-6.664 19.95-13.857 39.714-21.58 59.317-7.721 19.603-15.707 39.073-24.963 58.143zM390 1354c6.871-13.169 14.493-25.938 22.828-38.245 7.99-12.379 16.78-24.28 25.598-36.103 8.816-11.823 18.113-23.276 27.835-34.384 9.613-11.334 19.876-22.108 30.739-32.268-6.887 13.176-14.536 25.946-22.908 38.245-7.99 12.352-16.78 24.254-25.598 36.077-8.816 11.823-18.14 23.275-27.862 34.384-9.577 11.34-19.805 22.122-30.632 32.294zM995 1268c7.21 34.054 13.304 68.267 18.626 102.56 5.322 34.293 10.484 68.639 15.194 103.038 4.71 34.399 8.807 69.01 12.4 103.515 3.591 34.505 6.864 69.01 8.78 103.887-7.238-34.054-13.304-68.294-18.626-102.56-5.322-34.266-10.484-68.665-15.167-103.038-4.683-34.372-8.807-68.877-12.373-103.515-3.565-34.638-6.892-69.143-8.834-103.887zM1034 1261c10.384 33.784 19.998 67.754 28.842 101.91 8.995 34.095 17.274 68.348 25.393 102.655 8.12 34.307 15.629 68.746 22.634 103.319 7.005 34.572 13.559 69.092 19.131 104.116-10.437-33.66-20.06-67.613-28.869-101.857-8.995-34.094-17.274-68.348-25.366-102.655-8.093-34.307-15.629-68.746-22.634-103.319-7.005-34.572-13.532-69.278-19.131-104.169zM1191 1203c14.161 17.23 27.256 35.128 40.004 53.346 12.748 18.218 24.909 36.622 36.937 55.213 12.027 18.591 23.495 37.53 34.536 56.76 11.041 19.232 21.869 38.596 31.523 58.681-14.188-17.23-27.283-35.128-40.004-53.346-12.72-18.218-24.935-36.489-36.937-55.16-12-18.67-23.495-37.555-34.536-56.76s-21.869-38.65-31.523-58.734zM1205 1167c15.925 10.589 31.054 22.316 45.838 34.254 14.783 11.939 29.196 24.38 43.448 37.06 14.253 12.68 27.976 25.466 41.565 38.993 13.59 13.527 26.754 27.054 39.149 41.693-15.925-10.589-31.054-22.29-45.838-34.254-14.783-11.965-29.196-24.354-43.422-36.928-14.226-12.574-28.081-25.625-41.564-39.046-13.484-13.42-26.781-27.16-39.176-41.772zM1055 401c1.844-33.747 4.97-67.36 8.524-100.895 3.553-33.534 7.695-67.015 12.077-100.443 4.382-33.427 9.378-66.775 14.91-100.07C1096.04 66.297 1101.838 33.109 1109 0c-1.817 33.773-4.943 67.387-8.497 100.921-3.553 33.535-7.722 67.016-12.104 100.443-4.382 33.428-9.512 66.83-14.856 100.07-5.344 33.242-11.409 66.51-18.543 99.566zM1108 357c6.313-26.948 13.847-53.497 21.778-79.806 7.932-26.31 16.447-52.593 25.147-78.716 8.701-26.123 18.038-52.06 27.827-77.837C1192.54 94.863 1202.647 69.219 1214 44c-6.313 26.948-13.82 53.497-21.752 79.806-7.931 26.31-16.446 52.593-25.173 78.716-8.728 26.123-18.065 52.06-27.853 77.81-9.789 25.752-19.948 51.423-31.222 76.668zM978.814 295c-2.481-19.649-3.722-39.324-4.566-59-.844-19.676-1.166-39.351-1.24-59-.075-19.649.421-39.351 1.414-59 .992-19.649 2.233-39.351 4.764-59 2.482 19.676 3.747 39.351 4.591 59 .844 19.649 1.142 39.351 1.216 59.027.074 19.675-.447 39.324-1.44 59-.992 19.675-2.233 39.324-4.739 58.973zM1352 375c15.203-17.297 31.28-33.665 47.757-49.713 16.476-16.049 33.11-31.619 50.011-47.056 16.9-15.438 34.226-30.37 51.896-44.957 17.67-14.588 35.552-28.91 54.336-42.274-15.203 17.324-31.254 33.691-47.624 49.74-16.37 16.048-33.111 31.619-50.038 47.03-16.927 15.41-34.226 30.37-51.896 44.93-17.67 14.56-35.684 28.935-54.442 42.3zM1246 501c31.227-25.425 62.932-50.184 95.114-74.28 32.085-24.254 64.595-47.87 97.21-71.406 32.616-23.536 65.55-46.514 98.83-69.146C1570.433 263.536 1603.95 241.382 1638 220c-31.227 25.442-62.932 50.264-95.114 74.465-32.085 24.228-64.595 47.87-97.184 71.38-32.59 23.51-65.576 46.488-98.856 69.147C1313.567 457.65 1280.13 479.618 1246 501zM1309 672c36.154 17.154 71.954 35.026 107.4 53.618 35.489 18.433 70.633 37.53 105.697 56.735 35.064 19.205 69.756 39.022 104.315 59.239 34.56 20.216 68.773 40.886 102.588 62.408-36.172-17.171-71.963-35.044-107.373-53.618-35.516-18.433-70.633-37.53-105.697-56.762-35.065-19.231-69.81-39.022-104.316-59.212-34.506-20.19-68.8-40.913-102.614-62.408zM1431 783c22.239 12.607 43.707 26.22 64.936 40.204 21.229 13.985 42.086 28.472 62.837 43.118 20.75 14.646 41.13 29.796 61.11 45.37 19.98 15.572 39.854 31.41 59.117 48.308-22.239-12.58-43.733-26.194-64.936-40.178-21.202-13.984-42.033-28.365-62.757-43.118-20.724-14.752-41.103-29.822-61.11-45.395C1470.19 815.736 1450.13 799.924 1431 783z" transform="translate(0 -369) translate(-212 369)"/>
        </g>
      </g>
    </g>
  </svg>;
}

function SvgInstaStoriesIcon() {
  return <svg viewBox="0 0 144 144">
    <defs>
        <linearGradient id="ry29w3ijha" x1="6.731%" x2="93.591%" y1="93.485%" y2="6.619%">
            <stop offset="0%" stopColor="#FD5"/>
            <stop offset="50%" stopColor="#FF543E"/>
            <stop offset="100%" stopColor="#C837AB"/>
        </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
        <g>
            <g>
                <path fill="url(#ry29w3ijha)" fillRule="nonzero" d="M9.6 10.114C-1.65 21.799.652 34.213.652 71.924c0 31.316-5.464 62.71 23.133 70.1 8.93 2.297 88.05 2.297 96.968-.011 11.906-3.072 21.593-12.73 22.917-29.569.185-2.35.185-78.649-.006-81.047-1.407-17.937-12.449-28.274-26.997-30.368-3.335-.483-4.003-.626-21.11-.656C34.873.403 21.571-2.3 9.6 10.113z" transform="translate(-681 -1827) translate(681 1827)"/>
                <g stroke="#FFF">
                    <path fill="#FFF" fillRule="nonzero" strokeWidth="3" d="M61.173 43.187H46.785V28.798c0-.992-.806-1.798-1.8-1.798-.992 0-1.798.806-1.798 1.798v14.39H28.798c-.992 0-1.798.805-1.798 1.798s.806 1.799 1.798 1.799h14.39v14.388c0 .993.805 1.799 1.798 1.799s1.799-.806 1.799-1.799V46.785h14.388c.993 0 1.799-.806 1.799-1.8 0-.992-.806-1.798-1.799-1.798z" transform="translate(-681 -1827) translate(681 1827) translate(27 27)"/>
                    <path strokeLinecap="round" strokeWidth="10" d="M45 90c24.853 0 45-20.147 45-45S69.853 0 45 0" transform="translate(-681 -1827) translate(681 1827) translate(27 27)"/>
                    <path strokeDasharray="18 16" strokeLinecap="round" strokeLinejoin="round" strokeWidth="10" d="M45 0C20.147 0 0 20.147 0 45s20.147 45 45 45" transform="translate(-681 -1827) translate(681 1827) translate(27 27)"/>
                </g>
            </g>
        </g>
    </g>
  </svg>;
}

function SvgInstagramIcon() {
  return <svg viewBox="0 0 144 144">
    <defs>
        <linearGradient id="6to6641yoa" x1="6.731%" x2="93.591%" y1="93.485%" y2="6.619%">
            <stop offset="0%" stopColor="#FD5"/>
            <stop offset="50%" stopColor="#FF543E"/>
            <stop offset="100%" stopColor="#C837AB"/>
        </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
        <g fillRule="nonzero">
            <g>
                <path fill="url(#6to6641yoa)" d="M9.6 10.114C-1.65 21.799.652 34.213.652 71.924c0 31.316-5.464 62.71 23.133 70.1 8.93 2.297 88.05 2.297 96.968-.011 11.906-3.072 21.593-12.73 22.917-29.569.185-2.35.185-78.649-.006-81.047-1.407-17.937-12.449-28.274-26.997-30.368-3.335-.483-4.003-.626-21.11-.656C34.873.403 21.571-2.3 9.6 10.113z" transform="translate(-417 -1827) translate(417 1827)"/>
                <path fill="#FFF" d="M72.221 19.097c-21.659 0-42.226-1.927-50.082 18.235-3.245 8.327-2.774 19.142-2.774 34.627 0 13.589-.436 26.36 2.774 34.622 7.838 20.173 28.572 18.24 50.07 18.24 20.74 0 42.125 2.16 50.077-18.24 3.25-8.411 2.773-19.065 2.773-34.622 0-20.65 1.14-33.983-8.876-43.992-10.14-10.14-23.854-8.87-43.986-8.87h.024zm-4.736 9.526c45.18-.071 50.93-5.094 47.756 64.68-1.127 24.677-19.917 21.969-43.014 21.969-42.113 0-43.324-1.205-43.324-43.336 0-42.62 3.34-43.289 38.582-43.325v.012zm32.95 8.775c-3.5 0-6.34 2.84-6.34 6.34 0 3.502 2.84 6.342 6.34 6.342 3.502 0 6.342-2.84 6.342-6.341 0-3.502-2.84-6.341-6.341-6.341zm-28.214 7.414c-14.99 0-27.14 12.157-27.14 27.147 0 14.99 12.15 27.141 27.14 27.141s27.135-12.15 27.135-27.14-12.145-27.148-27.135-27.148zm0 9.527c23.294 0 23.323 35.241 0 35.241-23.287 0-23.323-35.241 0-35.241z" transform="translate(-417 -1827) translate(417 1827)"/>
            </g>
        </g>
    </g>
  </svg>;
}

function SvgInstaStoriesIconTransparent() {
  return <svg viewBox="0 0 80 80">
    <g fill="none" fill-rule="evenodd">
        <g stroke="#FFF">
            <g>
                <g>
                    <path fill="#FFF" fill-rule="nonzero" stroke-width="3" d="M48.939 34.55H37.428V23.039c0-.794-.645-1.439-1.44-1.439-.793 0-1.438.645-1.438 1.439v11.51H23.039c-.794 0-1.439.646-1.439 1.44 0 .794.645 1.439 1.439 1.439h11.51v11.51c0 .795.646 1.44 1.44 1.44.794 0 1.439-.645 1.439-1.44v-11.51h11.51c.795 0 1.44-.645 1.44-1.44 0-.793-.645-1.438-1.44-1.438z" transform="translate(-677 -1832) translate(633 1800) translate(48 36)"/>
                    <path stroke-linecap="round" stroke-width="7" d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0" transform="translate(-677 -1832) translate(633 1800) translate(48 36)"/>
                    <path stroke-dasharray="16 16" stroke-linecap="round" stroke-linejoin="round" stroke-width="7" d="M36 0C16.118 0 0 16.118 0 36s16.118 36 36 36" transform="translate(-677 -1832) translate(633 1800) translate(48 36)"/>
                </g>
            </g>
        </g>
    </g>
  </svg>;
}

function SvgInstagramIconTransparent() {
  return <svg viewBox="0 0 72 72">
    <g fill="none" fill-rule="evenodd">
        <g fill="#FFF" fill-rule="nonzero">
            <g>
                <path d="M84 36.035c-14.745 0-28.747-1.311-34.095 12.404-2.21 5.665-1.889 13.022-1.889 23.556 0 9.244-.296 17.931 1.889 23.551 5.336 13.724 19.452 12.41 34.088 12.41 14.12 0 28.679 1.468 34.092-12.41 2.213-5.721 1.888-12.968 1.888-23.551 0-14.048.776-23.117-6.042-29.926-6.904-6.899-16.24-6.034-29.946-6.034H84zm-3.224 6.48c30.759-.049 34.673-3.465 32.513 43.999-.768 16.787-13.56 14.945-29.284 14.945-28.67 0-29.495-.82-29.495-29.48 0-28.993 2.274-29.448 26.266-29.472v.008zm22.433 5.969c-2.383 0-4.316 1.932-4.316 4.313 0 2.382 1.933 4.314 4.316 4.314 2.384 0 4.317-1.932 4.317-4.314 0-2.381-1.933-4.313-4.317-4.313zm-19.208 5.044c-10.205 0-18.478 8.27-18.478 18.467s8.273 18.463 18.478 18.463c10.205 0 18.473-8.266 18.473-18.463 0-10.197-8.268-18.467-18.473-18.467zm0 6.48c15.858 0 15.878 23.974 0 23.974-15.854 0-15.879-23.974 0-23.974z" transform="translate(-96 -1836) translate(48 1800)"/>
            </g>
        </g>
    </g>
  </svg>;
}
